import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

interface CoAgentFilterState {
  selectedCoAgentIds: number[];
  loading: boolean;
  error: string | null;
  saving: boolean;
}

const initialState: CoAgentFilterState = {
  selectedCoAgentIds: [],
  loading: false,
  error: null,
  saving: false,
};

const coAgentFilterSlice = createSlice({
  name: "coAgentFilter",
  initialState,
  reducers: {
    loadCoAgentFilterPending: (state) => {
      state.loading = true;
      state.error = null;
    },
    loadCoAgentFilterFulfilled: (state, action: PayloadAction<number[]>) => {
      state.loading = false;
      state.selectedCoAgentIds = action.payload;
      state.error = null;
    },
    loadCoAgentFilterRejected: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    saveCoAgentFilterPending: (state) => {
      state.saving = true;
      state.error = null;
    },
    saveCoAgentFilterFulfilled: (state, action: PayloadAction<number[]>) => {
      state.saving = false;
      state.selectedCoAgentIds = action.payload;
      state.error = null;
    },
    saveCoAgentFilterRejected: (state, action: PayloadAction<string>) => {
      state.saving = false;
      state.error = action.payload;
    },
    setCoAgentFilter: (state, action: PayloadAction<number[]>) => {
      state.selectedCoAgentIds = action.payload;
    },
    clearCoAgentFilter: (state) => {
      state.selectedCoAgentIds = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  },
});

export const {
  loadCoAgentFilterPending,
  loadCoAgentFilterFulfilled,
  loadCoAgentFilterRejected,
  saveCoAgentFilterPending,
  saveCoAgentFilterFulfilled,
  saveCoAgentFilterRejected,
  setCoAgentFilter,
  clearCoAgentFilter,
} = coAgentFilterSlice.actions;

export default coAgentFilterSlice.reducer;
